import React, {CSSProperties, useRef, useState} from 'react'
import {MdArrowDropDown, MdArrowForward} from 'react-icons/md'
import classnames from 'classnames'
import Link from 'next/link'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function Dropdown({name, ref, subCategories, className, id}) {
  const {items} = subCategories
  const [active, setActive] = useState(false)
  const internalRef = useRef()
  const finalRef = ref || internalRef
  const {t} = useTranslation('generic')

  const subMenuStyle = (): CSSProperties => {
    if (!finalRef.current) {
      return {display: 'none'}
    }

    const {offsetHeight, offsetLeft} = finalRef.current
    return {position: 'absolute', top: offsetHeight, left: offsetLeft - 5}
  }

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}>
      <Link href={`/pedir/category/${id}`} prefetch={false}>
        <a
          ref={finalRef}
          style={active ? {color: 'var(--primary-color)'} : {}}
          className={className}>
          {name}
          {items.length > 0 && <MdArrowDropDown />}
        </a>
      </Link>
      {active && items.length > 0 ? (
        <div className={styles.subMenu} style={subMenuStyle()}>
          <div className={styles.internalContainer}>
            {items.map((item, idx) => (
              <Link href={`/pedir/category/${item._id}`} key={idx}>
                <a className={classnames(styles.item, styles.grey, styles.clickable)}>
                  {item.name}
                </a>
              </Link>
            ))}
            <Link href={`/pedir/category/${id}`}>
              <a className={classnames(styles.item, styles.clickable)}>
                <span className={styles.viewAll}> {t('fields.showAll')} </span>
                <MdArrowForward color="red" />
              </a>
            </Link>
          </div>
        </div>
      ) : null}
    </div>
  )
}
